import { connect } from 'react-redux';
import CheckboxSection from './CheckboxSection';
import { setInputDataToSend } from '../../../../store/form/actions';
import { getInputDataToSend } from '../../../../store/form/selectors';

const mapStateToProps = (state) => ({
  inputData: getInputDataToSend(state),
});

const mapDispatchToProps = (dispatch) => ({
  setInputDataToSend: (key, data) => {
    dispatch(setInputDataToSend(key, data));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckboxSection);
